export enum WalletErrorCode {
  rejectedNum = 4001,
  rejectedStr = 'ACTION_REJECTED',
  locked = 500,
  notAuth = 4100,
  UNPREDICTABLE_GAS_LIMIT = 'UNPREDICTABLE_GAS_LIMIT'
}

export const TX_SUCCESS = 1;
